export default __webpack_public_path__ + "static/media/CapaGroupChat.38daf519.png";